const childRoutes = (prop) => [
  {
    path: 'registration-list',
    name: prop + '.registration_list',
    meta: { auth: true },
    component: () => import('../pages/registration-list/List.vue')
  },
  {
    path: 'recommended-list',
    name: prop + '.recommended_list',
    meta: { auth: true },
    component: () => import('../pages/recommended-list/List.vue')
  },
  {
    path: 'approve-list',
    name: prop + '.approve_list',
    meta: { auth: true },
    component: () => import('../pages/approve-list/List.vue')
  },
  {
    path: 'demand-order-entry',
    name: prop + '.demand_order_entry',
    meta: { auth: true },
    component: () => import('../pages/demand-order-entry/Form.vue')
  },
  {
    path: 'quatation-entry',
    name: prop + '.quatation_entry',
    meta: { auth: true },
    component: () => import('../pages/quatation-entry/List.vue')
  },
  {
    path: 'quotation-request-approve',
    name: prop + '.quotation_request_approve',
    meta: { auth: true },
    component: () => import('../pages/quotation-request-approve/List.vue')
  },
  {
    path: 'delivery-order-entry',
    name: prop + '.delivery_order_entry',
    meta: { auth: true },
    component: () => import('../pages/delivery-order-entry/List.vue')
  },
  {
    path: 'delivery-order-list',
    name: prop + '.delivery_order_list',
    meta: { auth: true },
    component: () => import('../pages/delivery-order-list/List.vue')
  },
  {
    path: 'delivery-order-receive',
    name: prop + '.delivery_order_receive',
    meta: { auth: true },
    component: () => import('../pages/delivery-order-receive/List.vue')
  },
  {
    path: 'delivery-order-received-list',
    name: prop + '.delivery_order_received_list',
    meta: { auth: true },
    component: () => import('../pages/delivery-order-received/List.vue')
  },
  {
    path: 'delivery-order-adjust',
    name: prop + '.delivery_order_adjust',
    meta: { auth: true },
    component: () => import('../pages/return-and-adjust/List.vue')
  }
]
const routes = [{
  path: '/production-service/retailer-dealer-management',
  name: 'production_service.retailer_dealer_management',
  component: () => import('@/layouts/ProductionLayout.vue'),
  meta: { auth: true },
  children: childRoutes('production_service.retailer_dealer_management')
}]

export default routes
